import { CommonModule } from '@angular/common';
import { HttpErrorResponse } from '@angular/common/http';
import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatPaginatorModule, PageEvent } from '@angular/material/paginator';
import { NgBusyModule } from 'ng-busy';
import { takeUntil, finalize } from 'rxjs';
import { Subject } from 'rxjs/internal/Subject';
import { RestClientService } from 'src/app/_core/services/rest-client.service';
import { UtilitiesService } from 'src/app/_core/services/utilities.service';
import { SessionService } from 'src/app/shared/services/sessionStorage.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-direction',
  standalone: true,
  imports: [CommonModule, FormsModule, MatPaginatorModule, NgBusyModule],
  templateUrl: './direction.component.html',
  styleUrl: './direction.component.css',
})
export class DirectionComponent implements OnInit {
  private destroy$ = new Subject<void>();

  itemsDirection: any[] = [];
  itemToSave: any = {};
  itemToUser: any = {};
  itemToSearch: any = {};
  showModal = false;
  isLoading: boolean = false;
  loading = false;
  currentUser: any;
  showModalMembre: boolean = false;
  membreItems: any[] = [];
  totalMembre: number = 0;
  itemsPerPage = 5;
  itemsPerPageMembre = 5;
  currentPage = 0;
  itemsUser: any = {};
  currentPageMembre = 0;
  totalItems: number = 0;
  showUserModal = false;
  loadingUsers = false;
  usersList: any[] = [];
  selectedUserId: number | null = null;
  selectedDirection: any = null;
  selectedMembreItem: any = null;
  activeDropdown: number | string | null = null;

  ngOnInit(): void {
    this.currentUser = JSON.parse(
      sessionStorage.getItem('currentUser') || '{}'
    );
    this.getDirection();
  }


  constructor(
    private cdr: ChangeDetectorRef,
    private restClient: RestClientService,
    private utilitiesService: UtilitiesService,
        private sessionStorage: SessionService,
  ) {}

  pageChanged(event: PageEvent) {
    this.currentPage = event.pageIndex;
    this.itemsPerPage = event.pageSize;
    this.getDirection();
  }

  openModal(item?: any) {
    this.activeDropdown = null;
    if (item) {
      this.itemToSave = {
        id: item.id,
        nom: item.nom || '',

        //roleId: item.roleId || '',
      };
    } else {
      // Pour l'ajout - réinitialiser avec des valeurs vides
      this.itemToSave = {
        id: null,
        nom: '',
        //roleId: '',
      };
    }
    this.showModal = true;
  }
  openMembreModal(id?: number) {
    this.activeDropdown = null;
    this.loading = true;

    // Vérifiez que demandeId est bien défini
    console.log('ID demande à consulter:', id);

    const request = {
      user: this.currentUser.id,
      data: id ? { id: id } : {},
      isSimpleLoading: false,
      locale: 'fr',
      size: 100,
      index: 0,
    };

    console.log('Requête membre:', request);

    this.restClient.post('directions/getUsersByDirection', request).subscribe({
      next: (res) => {
        this.loading = false;
        console.log('Réponse API:', res);
        if (!res.hasError) {
          this.membreItems = res.items;
          this.totalMembre = res.count;
          this.selectedMembreItem = { id: id };
          this.showModalMembre = true;
        } else {
          this.utilitiesService.showNotification(
            "Une erreur s'est produite lors de la récupération des membres",
            'error'
          );
        }
        this.cdr.markForCheck();
      },
      error: (err) => {
        console.error('Erreur:', err);
        this.loading = false;
        this.utilitiesService.showNotification(
          "Une erreur inattendue s'est produite",
          'error'
        );
      },
    });
  }
  openModaladdUser(item?: any) {
    this.activeDropdown = null;
    if (item) {
      this.itemToUser = {
        id: item.id,
        nom: item.nom || '',
      };
    } else {
      this.itemToUser = {
        id: null,
        nom: '',
        
      };
    }
    this.showModal = true;
  }
  pageChangedMembre(event: PageEvent) {
    this.currentPageMembre = event.pageIndex;
    this.itemsPerPageMembre = event.pageSize;
  }
  getUser() {
    if (this.isLoading) return;

    this.isLoading = true;
    const request = {
      isSimpleLoading: false,
      user: this.currentUser.id,
      data: {
        // nom: this.itemToSearch.nom || '',
        // roleId: this.itemToSearch.roleId || '',
      },
    };

    this.restClient
      .post('users/getByCriteria', request)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (res: any) => {
          // console.log('Réponse API Users:', res);
          this.totalItems = res.count;
          // console.log('totalUser', this.totalItems);

          this.itemsUser = res?.items?.length > 0 ? res.items : [];
          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error(
            'Erreur lors de la récupération des utilisateurs:',
            err
          );
          this.itemsUser = [];
        },
      });

    this.cdr.markForCheck();
  }

  // 
  closeUserModal(): void {
    this.showUserModal = false;
    this.selectedDirection = null;
    this.selectedUserId = null;
  }
  selectUser(userId: number): void {
    console.log('User ID sélectionné:', userId); 
    this.selectedUserId = userId;
    console.log('selectedUserId après affectation:', this.selectedUserId); 
  }

  openModalAddUser(directionId: number): void {
    console.log('Direction ID reçue:', directionId);
    this.activeDropdown = null; 
    this.selectedDirection = directionId;
    console.log('selectedDirection après affectation:', this.selectedDirection);
    this.selectedUserId = null;
    this.getUser();
    this.showUserModal = true;
  }
  closeModalMembre() {
    this.showModalMembre = false;
    this.membreItems = [];
    this.selectedMembreItem = null;
  }

  getPaginatedMembre() {
    if (!this.membreItems) return [];
    const start = this.currentPageMembre * this.itemsPerPageMembre;
    return this.membreItems.slice(start, start + this.itemsPerPageMembre);
  }

  toggleDropdown(id: number | string): void {
    if (this.activeDropdown === id) {
      this.activeDropdown = null;
    } else {
      this.activeDropdown = id;
    }
  }
  getDirection(resetPagination: boolean = false) {
    if (this.isLoading) return;
     this.isLoading = true;
  
  if (resetPagination || this.itemToSearch.nom?.trim()) {
    this.currentPage = 0; 
  }


     const request: any = {
    isSimpleLoading: false,
    user: this.currentUser.id,
    data: {
      nom: this.itemToSearch.nom || '',
      prenoms: this.itemToSearch.prenoms || '',
    },
  };

  if (!resetPagination && !this.itemToSearch.nom?.trim()) {
    request.index = this.currentPage;
    request.size = this.itemsPerPage;
  } else if (!resetPagination) {
    request.index = this.currentPage;
    request.size = this.itemsPerPage;
  }

    this.restClient
      .post('directions/getByCriteria', request)
      .pipe(
        takeUntil(this.destroy$),
        finalize(() => {
          this.isLoading = false;
        })
      )
      .subscribe({
        next: (res: any) => {
          // console.log('Réponse API Users:', res);
          this.totalItems = res.count;
          // console.log('totalUser', this.totalItems);

          this.itemsDirection = res?.items?.length > 0 ? res.items : [];
          this.cdr.markForCheck();
        },
        error: (err) => {
          console.error('Erreur lors de la récupération des Directions:', err);
          this.itemsDirection = [];
        },
      });

    this.cdr.markForCheck();
  }

  onSearch() {
  this.getDirection(true);
}

  openModaladdUse() {}

  confirmSave(item: any) {

    if (!item.nom || item.nom.trim() === '') {
      this.utilitiesService.showNotification(
        'Veuillez renseigner le nom de la direction.',
        'error'
      );
      return;
    }

    this.loading = true;
    let objToSave = Object.assign({}, item);

    const isUpdate = objToSave.id != null;
    const actionText = isUpdate ? 'modifier' : 'enregistrer';

    const textMessage = isUpdate ? 'modifiée' : 'enregistrée';
    const article = /^[aeiouh]/i.test(actionText) ? "d'" : 'de '; 

    Swal.fire({
      title: 'Direction',
      text: `Vous êtes sur le point  ${article }${actionText} une direction. Voulez-vous poursuivre cette action ?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff7900',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        const endpoint = isUpdate ? 'directions/update' : 'directions/create';

        const request = {
          user: this.currentUser.id,
          datas: [objToSave],
        };

        this.restClient
          .post(endpoint, request)
          .pipe(
            takeUntil(this.destroy$),
            finalize(() => ((this.loading = false), this.cdr.markForCheck()))
          )
          .subscribe({
            next: (res) => {
              if (!res.hasError) {
                this.utilitiesService.showNotification(
                  `Direction ${textMessage} avec succès`,
                  'success'
                );
                this.closeModal();
                this.getDirection();
              } else {
                const apiErrorMessage = res.status?.message || 
                'Une erreur est survenue lors de l\'opération';
this.utilitiesService.showNotification(apiErrorMessage, 'error');


                this.cdr.markForCheck();
              }
            },
             error: (err: HttpErrorResponse) => {
                      console.error('Erreur API:', err);
                      
                      let errorMessage = 'Une erreur s\'est produite lors de l\'enregistrement de la réunion';
                      
                      if (err.error?.status) {
                        errorMessage = err.error.status.message;
                      } else if (err.error?.message) {
                        
                        errorMessage = err.error.message;
                      } else if (err.message) {
                        errorMessage = err.message;
                      }
                      
                      this.utilitiesService.showNotification(errorMessage, 'error');
                    },
          });
      } else {
        this.loading = false;
      }
    });
  }

  addUserDirection(): void {
    console.log('Début de addUserDirection');
    console.log('selectedDirection:', this.selectedDirection);
    console.log('selectedUserId:', this.selectedUserId);
  
    this.isLoading = true; // Activer le loader
  
    if (!this.selectedDirection || this.selectedDirection === null) {
      console.error('Direction non sélectionnée');
      this.utilitiesService.showNotification(
        'Veuillez sélectionner une direction valide',
        'error'
      );
      this.isLoading = false;
      this.cdr.markForCheck();
      return;
    }
  
    if (!this.selectedUserId || this.selectedUserId === null) {
      console.error('Utilisateur non sélectionné');
      this.utilitiesService.showNotification(
        'Veuillez sélectionner un utilisateur',
        'error'
      );
      this.isLoading = false;
      this.cdr.markForCheck();
      return;
    }
  
    Swal.fire({
      title: 'Direction',
      text: "Vous êtes sur le point d'associer un utilisateur à une direction. Voulez-vous poursuivre cette action ?",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#ff7900',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Oui',
      cancelButtonText: 'Non',
    }).then((result) => {
      if (result.value) {
        const request = {
          data: {
            userId: this.selectedUserId,
            directionIds: [this.selectedDirection],
          },
          user: this.currentUser.id,
        };
  
        console.log('Requête envoyée:', JSON.stringify(request));
  
        this.restClient
          .post('user-directions/addUserToDirections', request)
          .pipe(
            takeUntil(this.destroy$),
            finalize(() => {
              this.isLoading = false;
              this.cdr.markForCheck();
            })
          )
          .subscribe({
            next: (res) => {
              console.log('Réponse reçue:', res);
              if (!res.hasError) {
                this.utilitiesService.showNotification(
                  'Utilisateur associé à la direction avec succès',
                  'success'
                );
                this.closeUserModal();
                this.getDirection();
              } else {
                const apiErrorMessage = res.status?.message ||
                  "Une erreur est survenue lors de l'opération";
                this.utilitiesService.showNotification(apiErrorMessage, 'error');
                this.cdr.markForCheck();
              }
            },
            error: (err: HttpErrorResponse) => {
              console.error('Erreur API:', err);
              let errorMessage = "Une erreur s'est produite lors de l'enregistrement de la réunion";
              if (err.error?.status) {
                errorMessage = err.error.status.message;
              } else if (err.error?.message) {
                errorMessage = err.error.message;
              } else if (err.message) {
                errorMessage = err.message;
              }
              this.utilitiesService.showNotification(errorMessage, 'error');
            },
          });
      } else {
        this.isLoading = false;
        this.cdr.markForCheck();
      }
    });
  }

  
  confirmDelete(id: number) {
      Swal.fire({
        title: 'Confirmation',
        text: 'Voulez-vous vraiment supprimer cette direction ?',
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#f97316',
        cancelButtonColor: '#000',
        confirmButtonText: 'Oui',
        cancelButtonText: 'Non',
      }).then((result) => {
        if (result.value) {
          this.deleteItem(id);
        }
      });
  }

  deleteItem(id: number) {
    this.loading = true;
    const request = {
      user: this.currentUser.id,
      datas: [{ id: id }],
    };

    console.log(request);

    this.restClient.post('directions/delete', request).subscribe({
      next: (res) => {
        this.loading = false;
        if (!res.hasError) {
          this.utilitiesService.showNotification(
            'Direction supprimée avec succès',
            'success'
          );
          this.getDirection();
        } else {
          this.utilitiesService.showNotification(
            "Une erreur inattendue s'est produite lors de la suppression",
            'error'
          );
        }
      },
      error: (err) => {
        console.error('Erreur:', err);
        this.loading = false;
        this.utilitiesService.showNotification(
          "Une erreur inattendue s'est produite",
          'error'
        );

        this.cdr.markForCheck();
      },
    });
  }

  closeModal() {
    this.showModal = false;
  }


  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }

}
